import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EmitterService } from '../../core/utility/services/emitter.service';
import { R10FilterService } from '../shared/filters/filter-r10.service';
import { ContentViewerComponent } from './components/content-viewer.component';
import { OutletComponent } from './components/outlet/outlet.component';
import { CUSTOM_COMPONENTS } from './constants/customcomponents';
import { AnalyticsCoreURLService } from './services/analytics-core.url.service';
import { ChartConfigurationMapperService } from './services/chart-configuration.mapper.service';
import { ColorUtilityService } from './services/color.utility.service';
import { ConfigurationLoaderService } from './services/configuration-loader.service';
import { ConfigurationMapperService } from './services/configuration-mapper.service';
import { DatatableConfigurationMapperService } from './services/datatable-configuration.mapper.service';
import { EmbeddedComponents } from './services/embedded-components.service';

const embeddedComponents = CUSTOM_COMPONENTS;

@NgModule({
    declarations: [ContentViewerComponent, OutletComponent],
    exports: [ContentViewerComponent, OutletComponent],
    imports: [RouterModule],
    providers: [
        EmbeddedComponents,
        ConfigurationLoaderService,
        ConfigurationMapperService,
        ChartConfigurationMapperService,
        EmitterService,
        AnalyticsCoreURLService,
        ColorUtilityService,
        DatatableConfigurationMapperService,
        R10FilterService
    ]
})
export class AnalyticsCoreModule {}
